import { Typography, Stack } from '@newulife/common';
import Address from 'components/common/Address';
import { useNavigate, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { inputState } from 'state';
import { useField } from 'hooks/useContentfulApi';

export default function Shipping({ toggleEdit: toggleEditFromProps }) {
  const [data] = useField('banner1Ref');
  const navigate = useNavigate();
  const { search } = useLocation();
  const toggleEdit =
    typeof toggleEditFromProps === 'function'
      ? toggleEditFromProps
      : () => {
          navigate(`/steps/create-account#address-form${search}`);
        };

  const { item4 = '', item5 = '' } = data.fields;

  return <CurrentAddress title={item4} buttonTitle={item5} toggleEdit={toggleEdit} />;
}

export const CurrentAddress = ({ title }) => {
  const inputs = useRecoilValue(inputState);
  const { NAME_FIRST, NAME_LAST } = inputs;
  const fullName = `${NAME_FIRST} ${NAME_LAST}`;
  return (
    <Stack id="current-address" mt={4} mb={4} alignItems="center">
      <Typography variant="body1" mb={1.5} sx={{ fontSize: '18px' }}>
        {title}
      </Typography>
      <div style={{ textAlign: 'left', width: '100%', maxWidth: 'max-content' }}>
        <Address address={getCurrentAddress(inputs)} fullName={fullName} />
      </div>
    </Stack>
  );
};

function getCurrentAddress(inputs) {
  const address = Object.keys(inputs)
    .filter(
      (input) =>
        input.includes(inputs.shippingAddressSameAsAccount ? 'ACCOUNT' : 'SHIPPING') &&
        inputs[input] !== '',
    )
    .reduce((acc, inputKey) => {
      const key = inputKey.split('_')[1] ? inputKey.split('_')[1] : inputKey;
      return { ...acc, [key]: inputs[inputKey] };
    }, {});

  return address;
}
